import React, { useEffect } from "react";
import PropTypes from "prop-types";
import MainContent from "../../MainContent";
import styles from "./LoadingScreen.module.css";

const LoadingScreen = ({
  title = "Please wait...",
  showContactInfo = true,
}) => {
  // Scroll to top when loading screen is shown
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className={styles.container}>
      <MainContent>
        <div className={styles.innerContainer}>
          <div className={styles.row}>
            <div className={`${styles.column} ${styles.centerColumn}`}>
              <h1 className={styles.title}>{title}</h1>
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.column}>
              <div className={styles.spinnerContainer}>
                <div className={styles.spinner}></div>
              </div>
            </div>
          </div>

          {showContactInfo && (
            <div className={styles.contactSection}>
              <h2 className={styles.contactTitle}>Prefer to call us?</h2>

              <div className={styles.contactInfo}>
                <p className={styles.contactText}>
                  Call us on{" "}
                  <a href="tel:03336660276" className={styles.phoneLink}>
                    0333 666 0276
                  </a>{" "}
                  to speak to a dedicated Business Energy Advisor
                </p>
              </div>

              <p className={styles.hoursText}>
                Lines open Mon - Thu 8.30am - 5.00pm and Fri 8.30am - 4.30pm
              </p>

              <div className={styles.linksContainer}>
                <a
                  href="/terms-of-use"
                  target="_blank"
                  className={styles.link}
                  rel="noopener noreferrer"
                >
                  Terms of use
                </a>
                <a
                  href="https://www.engie.co.uk/privacy-notice-and-cookies/"
                  target="_blank"
                  className={styles.link}
                  rel="noopener noreferrer"
                  aria-label="Read privacy policy (opens in new page)"
                >
                  Privacy policy
                </a>
              </div>
            </div>
          )}
        </div>
      </MainContent>
    </div>
  );
};

export default LoadingScreen;

LoadingScreen.propTypes = {
  title: PropTypes.string,
  showContactInfo: PropTypes.bool,
};
